import axios from "axios";

import { AXIOS_DEFAULT_CONFIG, routes } from "../../constants";

// Idempotent on the server: a second call returns the same payment, so a
// failed card is retried by calling this again.
const payTableRequest = async (id) => {
  const response = await axios.post(
    routes.payTableRequest(id),
    {},
    AXIOS_DEFAULT_CONFIG
  );
  return response;
};
export default payTableRequest;
